<template>
  <footer class="kbx-form-footer">
    <a
      klickbox-edit-item="button"
      :klickbox-edit-label="$t('edit.canvas.redirect_button')"
      class="kbx-btn"
      style="min-width: 100px"
      :style="stepStyle('button')">{{stepPreview.redirect_button_text}}</a>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    stepPreview: 'stepPreview',
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Button.vue?1d10c446
 **/